import styled from 'styled-components';

export const Container = styled.div`
	width: 100%;
	height: auto;
	background: linear-gradient(248.96deg, #e1e6ff 1.8%, #f8f7fc 99.47%);
	border-radius: 10px;
	position: relative;
	padding: 25px 20px 20px;
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

export const Title = styled.div`
	font-weight: 700;
	font-size: 24px;
	line-height: 28px;
	margin-bottom: 10px;
	color: #000000;
	width: calc(100% - 80px);
`;

export const Content = styled.div`
	font-weight: 400;
	font-size: 12px;
	line-height: 14px;
	color: #000000;
`;

export const Image = styled.img`
	position: absolute;
	width: 70px;
	height: 70px;
	top: 15px;
	right: 15px;
`;
